import { BaseEntityDTO, IBaseEntityDTO } from './base.entity.dto';
import { IRubricFieldDTO, RubricFieldDTO } from './rubric.field.dto';

export interface IRubricOptionDTO extends IBaseEntityDTO {
  name: string;
  order: number;
  field: IRubricFieldDTO;
}

export class RubricOptionDTO extends BaseEntityDTO implements IRubricOptionDTO {
  name: string;
  order: number;
  field: IRubricFieldDTO;
  constructor(data?: Partial<IRubricOptionDTO>) {
    super(data);
    this.name = data?.name || '';
    this.order = data?.order || 0;
    this.field = new RubricFieldDTO(data?.field);
  }
}
